const oauthDE = {
    consent: {
        title: "{{clientName}} wants to access your {{schoolName}} calendar",
        subtitle: "Signed in as {{userFullName}}. Review what {{clientName}} will be able to do.",
        scopes: {
            calendarRead: "See your calendar and availability",
            calendarWrite: "Create and change events, and manage invitations",
            calendarDelete: "Delete events"
        },
        delegationNote: "This app may act on behalf of other users you manage.",
        allow: "Allow",
        deny: "Deny",
        footer: "You can revoke access at any time.",
        redirecting: "Redirecting you back to {{clientName}}…",
        errors: {
            invalidRequest: "Invalid request",
            expired: "This authorization request has expired. Return to the app and try again.",
            decisionError: "Something went wrong while submitting your decision. Please try again."
        }
    }
}

export default oauthDE
